module.exports = __webpack_public_path__ + "img/stock4.fe0b0a94.png";